import {AlertController, App, Events} from 'ionic-angular';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {AppPreferences} from '../../shared/local/app-preferences.local';
import { Messages } from '../../helpers/messages';
import { handleMsgError } from '../../helpers/handle-error-message.helper';

/*
  Generated class for the AlertServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AlertServiceProvider {

	constructor(
		public http: Http,
		public alertCtrl: AlertController,
		public translate: TranslateService,
		public events: Events,
		public appPreferences: AppPreferences,
		public app: App
	) {

	}

	/**
	   * method create alert ionic
	   * @param title
	   * @param subTitle
	   * @param message
	   * @param cssClass
	   * @param inputs
	   * @param buttons
	   * @param enableBackdropDismiss
	   */
	create(title: string, subTitle: string, message: string, cssClass: string, inputs: Array<any>, buttons: Array<any>, enableBackdropDismiss: boolean = true) {
		let alert = this.alertCtrl.create({
			title: title,
			subTitle: subTitle,
			message: message,
			cssClass: cssClass,
			inputs: inputs,
			buttons: buttons,
			enableBackdropDismiss: enableBackdropDismiss
		});
		alert.present();
	}

	/**
	 * method create alert ionic dengan mola-mola
	 * @param title
	 * @param subTitle
	 * @param message
	 */
	createMola(message: string) {
		try {
			if (!message) {
				message = "Sorry, something went wrong";
			}
		} catch (error) {
			message = "Sorry, something went wrong";
		}

		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create(
				{
					message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
						+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
					enableBackdropDismiss: false,
					buttons: [{
						text: this.translate.instant('Dismiss'),
						handler: () => {
							resolve(true);
						}
					}]
				});
			alert.present();
		})
	}

	/**
	   * method create alert ionic dengan mola-mola
	   * @param title
	   * @param subTitle
	   * @param message
	   */
	createWarnMola(message: string) {
		console.log(message);
		try {
			if (message == "Invalid access token") {
				message = "Session expired";
			}
			else if (message == "Request Timeout") {
				message = "Request timeout";
			}
			else if (message == "You do not have permission") {
				message = "You do not have permission";
			}
			else if (message.indexOf("error_message:") > -1) {
				message = message.replace("error_message:", "");
			}
			else if (message == "Empty Response") {
				message = "Wrong Request Approval Setting";
			}
			else if (message == "Please try again") {
				message = "Please try again";
			}
			else if (message == "Failed Generate Request Number. Please Setting Document Numbering") {
				message = "Failed Generate Request Number. Please Setting Document Numbering";
			}
			else if (message == 'error masih punya anak buah') {
				message = 'error masih punya anak buah'
			}

			else {
				message = message ? message : "Sorry, something went wrong";
			}
		} catch (error) {
			message = "Sorry, something went wrong";
		}
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create({
				message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
					+ `<h6 style="color:#808080;"><b>` + this.translate.instant('Warning') + `</b></h6>`
					+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
				buttons: [{
					text: this.translate.instant('Dismiss'),
					handler: () => {
						resolve(true);
					}
				}],
				enableBackdropDismiss: false
			});
			alert.present();
		})
	}

	redirect(message: string) {
		if (message == "Invalid access token") {
			// this.events.publish('user:logout', '');
		}
		else if (message == "You do not have permission") {
			this.events.publish('user:goToHomePage', '');
		}
	}

	/**
     * method confirm alert ionic dengan mola-mola
	 *
     * @param title
     * @param subTitle
     * @param message
     */
	confirmMola(message: string, labelCancel: string = 'No', labelYes: string = 'Yes') {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create({
				message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
					+ `<h6 style="color:#808080;"><b>` + this.translate.instant('Confirmation') + `</b></h6>`
					+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
				buttons: [{
					text: this.translate.instant(labelCancel),
					handler: () => {
						resolve(false);
					}
				}, {
					text: this.translate.instant(labelYes),
					handler: () => {
						resolve(true);
					}
				}],
				enableBackdropDismiss: false
			});
			alert.present();
		})
	}

	confirmMessage(message: string) {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create({
				message: `<h6 style="color:#808080;"><b>` + this.translate.instant('Confirmation') + `</b></h6>`
					+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
				buttons: [{
					text: this.translate.instant('No'),
					handler: () => {
						resolve(false);
					}
				}, {
					text: this.translate.instant('Yes'),
					handler: () => {
						resolve(true);
					}
				}],
				enableBackdropDismiss: false
			});
			alert.present();
		})
	}

	confirmQuiz(totQuest: number, totTime: number, passingGrades: number, maxAttempt: number, attemptNo: number, status: any) {
		let timesUp = totTime == 0
			? ''
			: ", " + this.translate.instant(`which will take approximately `) + totTime + this.translate.instant(` minutes to finish`);
		if (passingGrades == 0 && maxAttempt == 0 && attemptNo == 0) {
			return new Promise((resolve, reject) => {
				let alert = this.alertCtrl.create({
					cssClass: 'notifQuizElr',
					message:
					`<h6 style="color:#808080;">` + this.translate.instant(`The quiz consists of `) + totQuest + this.translate.instant(` Question`)  + timesUp + `</h6>`
					+
					`<h6 style="color:#808080;">` + this.translate.instant(`At the end of the Quiz, your total score will be displayed.`) + `</h6>`
					+
					`<h6 style="color:#808080;">` + this.translate.instant(`Do you want to take the quiz now?`) + `</h6>`,
					buttons: [{
						text: this.translate.instant('No'),
						handler: () => {
							resolve(false);
						}
					}, {
						text: this.translate.instant('Yes'),
						handler: () => {
							resolve(true);
						}
					}],
					enableBackdropDismiss: false
				});
				alert.present();
			})
		} else if (status) {
			let remaining = maxAttempt - attemptNo;
			return new Promise((resolve, reject) => {
				let alert = this.alertCtrl.create({
					cssClass: 'notifQuizElr',
					message:
						`<h6 style="color:#808080;">` + this.translate.instant(`The quiz consists of `) + totQuest + this.translate.instant(` Question`) + timesUp + this.translate.instant(`. To pass this quiz, your score has to be at least `) + passingGrades + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`Scoring method: Latest attempt score, which means the final score of the latest attempt is taken.`) + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`If you pass in first attempt or before your all attempt is used, then your score is that attempt score`) + `</h6>`
						+
						`<h6 style="color:#ff0000;">` + remaining + this.translate.instant(` Attempt Remaining`) + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`Do you want to take the quiz now?`) + `</h6>`,
					buttons: [{
						text: this.translate.instant('No'),
						handler: () => {
							resolve(false);
						}
					}, {
						text: this.translate.instant('Yes'),
						handler: () => {
							resolve(true);
						}
					}],
					enableBackdropDismiss: false
				});
				alert.present();
			})
		} else {
			return new Promise((resolve, reject) => {
				let alert = this.alertCtrl.create({
					cssClass: 'notifQuizElr',
					message:
						`<h6 style="color:#808080;">` + this.translate.instant(`The quiz consists of `) + totQuest + this.translate.instant(` Question`) + timesUp + this.translate.instant(`. To pass this quiz, your score has to be at least `) + passingGrades + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`Scoring method: Latest attempt score, which means the final score of the latest attempt is taken.`) + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`If you pass in first attempt or before your all attempt is used, then your score is that attempt score`) + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`Only `) + maxAttempt + this.translate.instant(` attempt allowed.`) + `</h6>`
						+
						`<h6 style="color:#808080;">` + this.translate.instant(`Do you want to take the quiz now?`) + `</h6>`,
					buttons: [{
						text: this.translate.instant('No'),
						handler: () => {
							resolve(false);
						}
					}, {
						text: this.translate.instant('Yes'),
						handler: () => {
							resolve(true);
						}
					}],
					enableBackdropDismiss: false
				});
				alert.present();
			})
		}
	}

	confirmReport() {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create({
				message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
					+ `<h6 style="color:#808080;"><b>` + this.translate.instant('Confirmation') + `</b></h6>`
					+ `<h6 style="color:#808080;">` + this.translate.instant('Please choose one type of file..') + `</h6>`,
				buttons: [{
					text: this.translate.instant('Excel'),
					handler: () => {
						resolve('excel');
					}
				}, {
					text: this.translate.instant('PDF'),
					handler: () => {
						resolve('pdf');
					}
				}],
				enableBackdropDismiss: true
			});
			alert.present();
		})
	}

	createMolaMock(message: string, packages: any) {
		return new Promise((resolve, reject) => {
			let button = [{
				text: this.translate.instant('Dismiss'),
				handler: () => {
					resolve(false);
				}
			}, {
				text: this.translate.instant('List'),
				handler: () => {
					resolve(packages);
				}
			}]
			try {
				if (packages == null || packages == undefined || packages.length == 0) {
					button = [{
						text: this.translate.instant('Dismiss'),
						handler: () => {
							resolve(false);
						}
					}]
				}
			} catch (error) {

			}
			let alert = this.alertCtrl.create(
				{
					message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
						+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
					enableBackdropDismiss: false,
					buttons: button
				});
			alert.present();
		})
	}

	createMolaConfirm(message: string) {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create(
				{
					message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
						+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
					enableBackdropDismiss: false,
					buttons: [
						{
							text: this.translate.instant('No'),
							handler: () => {
								resolve(false);
							}
						}, {
							text: this.translate.instant('Yes'),
							handler: () => {
								resolve(true);
							}
						}]
				});
			alert.present();
		})
	}
	ConfirmYesdok(message: string) {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create(
				{
					message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" />`
						+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
					enableBackdropDismiss: false,
					buttons: [
						{
							text: this.translate.instant('Tidak Setuju'),
							handler: () => {
								resolve(false);
							}
						}, {
							text: this.translate.instant('Setuju'),
							handler: () => {
								resolve(true);
							}
						}]
				});
			alert.present();
		})
	}
	invalidtoken() {
		const alert = this.alertCtrl.create({
			cssClass: 'grd-alert',
			message: `
			<img src="assets/images/illustration___session_expired.png" width="40%" height="40%" />
			<h3>Access Token Invalid</h3>
			<h6>Upssss, sorry looks like you have to refresh your session to keep using GreatDay</h6>
			`,
			buttons: [
				{
					text: 'Refresh Session',
					handler: () => {
					}
				},
			]
		});
		alert.present();
	}

	confirmInvisee(message: string, labelCancel: string = 'No', labelYes: string = 'Yes') {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create({
				message: `<img src="assets/icon_new/investment/illustrasi-popup-invise.svg" width="90%" height="100%" />`
					+ `<h6 style="color:#808080;"><b>` + this.translate.instant('Confirmation') + `</b></h6>`
					+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
				buttons: [{
          text: this.translate.instant(labelCancel),
          cssClass: 'btn-cancel',
					handler: () => {
						resolve(false);
					}
				}, {
          text: this.translate.instant(labelYes),
          cssClass: 'btn-submit',
					handler: () => {
						resolve(true);
					}
				}],
        enableBackdropDismiss: false,
        cssClass: 'alert-invisee-custom'
			});
			alert.present();
		})
	}

	createInvisee(message: string) {
		try {
			if (!message) {
				message = "Sorry, something went wrong";
			}
		} catch (error) {
			message = "Sorry, something went wrong";
		}

		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create(
				{
					message: `<img src="assets/icon_new/investment/illustrasi-popup-invise.svg" width="90%" height="100%" />`
						+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
					enableBackdropDismiss: false,
					buttons: [{
						text: this.translate.instant('Dismiss'),
						cssClass: 'btn-confirm',
						handler: () => {
							resolve(true);
						}
					}]
				});
			alert.present();
		})
	}

	// Login Eror Message New : Author Fattah (ui/ux) | any problem? Create Ticket :D
	async newAlertMessage(title: string, message: string) {
		const version = await this.appPreferences.getVersionData();
		const alert = this.alertCtrl.create({
		  title: `<img src="assets/images/invalid-token.png">`,
		  subTitle: title,
		  message: message,
		  cssClass: 'Report-Problem',
		  buttons: [
			{
			  text: 'Take Me Back',
			  cssClass: 'top',
				role: 'cancel',
			  handler: () => {

			  }
			},
			  {
				  text: 'HELP AND SUPPORT',
				  cssClass: 'mid',
				  handler: () => {
					  this.app.getActiveNav().push('ProblemAccountPage',{from:'alert'})
				  },
			},
			{
			  text: `Version ${version}`,
			  cssClass: 'bottom',
			}
		  ],
		});
		alert.present();
	  }
	//   End Login Eror Message

	confirmationAlert(param: any) {
		return new Promise((resolve, reject) => {
			let message : string;
			const tempMessage: any[] = []
			if (param.message) {
				param.message.forEach(el => {
					tempMessage.push('<'+el.type + ' ' + 'class="' + el.style + '">' + el.text + '</' + el.type + '>')
				})
			}
			message = tempMessage.join("")
			const alert = this.alertCtrl.create({
				title: param.title ? param.title : undefined,
				subTitle: param.subTitle ? param.subTitle : undefined,
				message: `<div>` + message + `</div>`,
				enableBackdropDismiss: param.enableBackdropDismiss ? param.enableBackdropDismiss : false,
				buttons: [
					{
						text: param.labelCancel ? this.translate.instant(param.labelCancel) : this.translate.instant("No"),
						handler: () => {
							resolve(false);
						},
					},
					{
						text: param.labelYes ? this.translate.instant(param.labelYes) : this.translate.instant("Yes"),
						handler: () => {
							resolve(true);
						},
					},
				],
			});
			alert.present();
		});
	}

	warningAlert(param: any) {
		const defaultMessage =
			`<img src="assets/images/failed-alert.svg" />` +
			`<h6 style="color:#808080;">` +
			this.translate.instant(param.message) +
			`</h6>`;
		return new Promise((resolve, reject) => {
			const alert = this.alertCtrl.create({
				message: param.customMessage ? param.message : defaultMessage,
				enableBackdropDismiss: param.enableBackdropDismiss ? param.enableBackdropDismiss : false,
				buttons: [
					{
						text: this.translate.instant('Dismiss'),
						handler: () => {
							resolve(true);
						},
					},
				],
			});
			alert.present();
		});
	}

  presentError(error): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const message = handleMsgError(error, true);
        await this.createMola(message);
        resolve(true);
      }
      catch (error) {
        await this.createMola(Messages.SERVER_ERROR);
        resolve(true);
      }
    })
  }

	confirmCompanyPolicy(message: string) {
		return new Promise((resolve, reject) => {
			let alert = this.alertCtrl.create({
				message: `<h6 style="color:#808080;"><b>` + this.translate.instant('Confirmation') + `</b></h6>`
					+ `<h6 style="color:#808080;">` + this.translate.instant(message) + `</h6>`,
				cssClass: 'notifQuizElr',
				buttons: [{
					text: this.translate.instant('No'),
					handler: () => {
						resolve(false);
					}
				}, {
					text: this.translate.instant('Yes'),
					handler: () => {
						resolve(true);
					}
				}],
				enableBackdropDismiss: false
			});
			alert.present();
		})
	}
}



// WEBPACK FOOTER //
// ./src/providers/alert-service/alert-service.ts